import { render, staticRenderFns } from "./FontColor.vue?vue&type=template&id=71020bdc&scoped=true"
import script from "./FontColor.vue?vue&type=script&lang=js"
export * from "./FontColor.vue?vue&type=script&lang=js"
import style0 from "./FontColor.vue?vue&type=style&index=0&id=71020bdc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71020bdc",
  null
  
)

export default component.exports